export default `#version 300 es

precision highp float;
precision highp isampler2D;

uniform float u_animationProgress;

uniform float u_visibilityOpacity;
uniform float u_previousVisibilityOpacity;
uniform float u_applyMaskOpacity;
uniform float u_previousApplyMaskOpacity;

uniform float u_opacity;
uniform float u_saturation;

uniform bool u_removeColor;
uniform vec3 u_removeColorColor;
uniform float u_removeColorThreshold;
uniform float u_removeColorHardness;

uniform bool u_colorize;
uniform vec3 u_colorizeColor;

uniform bool u_renderGrid;
uniform vec4 u_renderGridColor;

uniform bool u_distortion;
uniform int u_distortionMeasure;
uniform vec4 u_distortionColor00;
uniform vec4 u_distortionColor01;
uniform vec4 u_distortionColor1;
uniform vec4 u_distortionColor2;
uniform vec4 u_distortionColor3;

uniform int u_scaleFactorForViewport;

uniform lowp sampler2DArray u_cachedTilesTextureArray;
uniform isampler2D u_cachedTilesResourceOriginPointsAndSizesTexture;
uniform isampler2D u_cachedTilesScaleFactorsTexture;

uniform float u_debugTriangles;
uniform float u_debugTiles;

in vec2 v_resourceTrianglePoint;
in float v_trianglePointDistortion;
in float v_trianglePointIndex;
in vec4 v_trianglePointBarycentric;
in float v_trianglePointInside;

out vec4 color;

void main() {
  float resourceTrianglePointX = v_resourceTrianglePoint.x;
  float resourceTrianglePointY = v_resourceTrianglePoint.y;

  
  ivec3 cachedTilesTextureSize = textureSize(u_cachedTilesTextureArray, 0);
  int cachedTilesCount = cachedTilesTextureSize.z;

  
  int smallestScaleFactor;
  bool found = false;
  int foundIndex;

  
  vec3 cachedTilesTexturePoint = vec3(0.0f, 0.0f, 0.0f);

  
  vec4 initialColor = vec4(0.0f, 0.0f, 0.0f, 0.0f);
  color = initialColor;

  
  for(int index = 0; index < cachedTilesCount; index += 1) {

    
    float cachedTileResourceOriginPointX = float(texelFetch(u_cachedTilesResourceOriginPointsAndSizesTexture, ivec2(0, (index * 4)), 0));
    float cachedTileResourceOriginPointY = float(texelFetch(u_cachedTilesResourceOriginPointsAndSizesTexture, ivec2(0, (index * 4) + 1), 0));
    float cachedTileDimensionWidth = float(texelFetch(u_cachedTilesResourceOriginPointsAndSizesTexture, ivec2(0, (index * 4) + 2), 0));
    float cachedTileDimensionHeight = float(texelFetch(u_cachedTilesResourceOriginPointsAndSizesTexture, ivec2(0, (index * 4) + 3), 0));

    int cachedTileScaleFactor = texelFetch(u_cachedTilesScaleFactorsTexture, ivec2(0, index), 0).r;

    
    if(resourceTrianglePointX >= cachedTileResourceOriginPointX &&
      resourceTrianglePointX < cachedTileResourceOriginPointX + cachedTileDimensionWidth &&
      resourceTrianglePointY >= cachedTileResourceOriginPointY &&
      resourceTrianglePointY < cachedTileResourceOriginPointY + cachedTileDimensionHeight) {

      
      
      
      
      
      if(!(smallestScaleFactor > 0) || cachedTileScaleFactor <= smallestScaleFactor) {
        smallestScaleFactor = cachedTileScaleFactor;
        found = true;
        foundIndex = index;

        float cachedTilePointX = (resourceTrianglePointX - cachedTileResourceOriginPointX) / float(cachedTileScaleFactor);
        float cachedTilePointY = (resourceTrianglePointY - cachedTileResourceOriginPointY) / float(cachedTileScaleFactor);

        float cachedTilesTexturePointX = cachedTilePointX / float(cachedTilesTextureSize.x);
        float cachedTilesTexturePointY = cachedTilePointY / float(cachedTilesTextureSize.y);

        cachedTilesTexturePoint = vec3(cachedTilesTexturePointX, cachedTilesTexturePointY, index);
      }
    }
  }

  if(found == true) {
    
    color = texture(u_cachedTilesTextureArray, cachedTilesTexturePoint);

    if(u_removeColorThreshold > 0.0f) {
  vec3 backgroundColorDiff = color.rgb - u_removeColorColor.rgb;
  float backgroundColorDistance = length(backgroundColorDiff);
  if(u_removeColor && backgroundColorDistance < u_removeColorThreshold) {
    float amount = smoothstep(u_removeColorThreshold - u_removeColorThreshold * (1.0f - u_removeColorHardness), u_removeColorThreshold, backgroundColorDistance);
    color = vec4(color.rgb * amount, amount);
  }
}

float gray = 0.21f * color.r + 0.71f * color.g + 0.07f * color.b;
color = vec4(color.rgb * (u_saturation) + (gray * (1.0f - u_saturation)), color.a);

if(u_colorize) {
  color = vec4((u_colorizeColor + color.rgb) * color.a, color.a);
}

float opacityFromVisibility = mix(u_previousVisibilityOpacity, u_visibilityOpacity, u_animationProgress);
float opacityFromApplyMask;
if (v_trianglePointInside == 1.0) {
  opacityFromApplyMask = 1.0;
} else {
  opacityFromApplyMask = mix(u_previousApplyMaskOpacity, u_applyMaskOpacity, u_animationProgress);
}
float opacity = u_opacity * opacityFromVisibility * opacityFromApplyMask;
color = vec4(color * opacity);
    if(u_distortion && opacityFromApplyMask != 0.0) {
  float trianglePointDistortion = v_trianglePointDistortion;

  
  
  trianglePointDistortion = floor(trianglePointDistortion * 10.0f) / 10.0f;

  
  float trianglePointDistortionMix = clamp(trianglePointDistortion, -1.0f, 1.0f);

  switch(u_distortionMeasure) {
    case 0:
      if(trianglePointDistortion > 0.0f) {
        color = mix(color, u_distortionColor00, trianglePointDistortionMix);
      } else {
        color = mix(color, u_distortionColor01, abs(trianglePointDistortionMix));
      }
      break;
    case 1:
      color = mix(color, u_distortionColor1, trianglePointDistortionMix);
      break;
    case 2:
      color = mix(color, u_distortionColor2, trianglePointDistortionMix);
      break;
    case 3:
      color = trianglePointDistortion == -1.0f ? u_distortionColor3 : color;
      break;
    default:
      color = color;
  }
}

if(u_renderGrid && opacityFromApplyMask != 0.0) {
  float gridSize = 20.0f * float(u_scaleFactorForViewport);
  float gridWidth = 2.0f * float(u_scaleFactorForViewport);
  if(mod(float(resourceTrianglePointX) + gridWidth / 2.0f, gridSize) < gridWidth || mod(float(resourceTrianglePointY) + gridWidth / 2.0f, gridSize) < gridWidth) {
    color = vec4(u_renderGridColor * opacity);
  }
}
    float viewportWidth = 4.0;

if(bool(u_debugTriangles)) {
  
  
  

  float barycentricTriangleDist = min(min(v_trianglePointBarycentric.x, v_trianglePointBarycentric.y), v_trianglePointBarycentric.z);
  
  
  float barycentricTriangleDistPixelSize = length(vec2(dFdx(barycentricTriangleDist), dFdy(barycentricTriangleDist)));
  
  float TriangleDistThreshold = viewportWidth * barycentricTriangleDistPixelSize / 2.0;

  if(barycentricTriangleDist < TriangleDistThreshold) {
    color = vec4(0.0, 0.0, 0.0, 1.0);
  }
}

if(bool(u_debugTiles)) {
  float resourceDist = min(cachedTilesTexturePoint.x, cachedTilesTexturePoint.y);
  
  
  float resourceDistPixelSize = length(vec2(dFdx(resourceDist), dFdy(resourceDist)));
  float resourceDistThreshold = viewportWidth * resourceDistPixelSize;

  float blueStrength = 1.0 - pow(1.0 - 0.2, log2(float(smallestScaleFactor)));
  color = mix(color, vec4(0.0, 0.2, 1.0, color.a), blueStrength);
  if(resourceDist < resourceDistThreshold) {
    color = vec4(0.0, 0.0, 1.0, 1.0);
  }
}
  }
}`